<template>
  <main class="py-10 px-4 max-w-7xl mx-auto">
    <h2 class="text-3xl font-bold text-center mb-10">Our Gallery</h2>

    <!-- Masonry-style staggered grid -->
    <div class="columns-1 sm:columns-2 md:columns-3 gap-4">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="mb-4 break-inside-avoid"
      >
        <img
          :src="image"
          alt="Gallery image"
          :class="['w-full rounded-xl object-cover shadow-md hover:scale-105 transition-transform duration-300', getImageHeight(index)]"
        />
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('../assets/images/Consult_16.jpg'),
        require('../assets/images/Consult_17.jpg'),
        require('../assets/images/Consult_20.jpg'),
        require('../assets/images/Consult_18.jpg'),
        require('../assets/images/Consult_19.jpg'),
        require('../assets/images/Consult_21.jpg'),
        // require('../assets/images/Consult_22.jpg'),
      ],
    };
  },
  methods: {
    getImageHeight(index) {
      const heights = ['h-48', 'h-60', 'h-72', 'h-80', 'h-64'];
      return heights[index % heights.length];
    },
  },
};
</script>

<style scoped>
.break-inside-avoid {
  break-inside: avoid;
}
</style>
